// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"eaa387ba","815":"34e07c1d"}[chunkId] + ".chunk.js";
};